import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { LayoutDashboard, LineChart, FileText, Bell, ArrowLeft } from "lucide-react";
import { Reveal } from "../components/Reveal";
import SeoHead from "../components/SeoHead";

const FEATURES = [
  { icon: LayoutDashboard, title: "Executive Dashboards", desc: "Live operational health across every domain, updated in real time." },
  { icon: LineChart, title: "Performance Reporting", desc: "Track KPIs, roadmap progress, and margin trends at a glance." },
  { icon: FileText, title: "Deliverable Library", desc: "Scorecards, playbooks, and SOPs — all in one secure place." },
  { icon: Bell, title: "Initiative Tracking", desc: "Know exactly where every roadmap initiative stands." },
];

export default function ClientPortal() {
  return (
    <div data-testid="portal-page" className="pt-[72px] bg-ink text-white relative overflow-hidden min-h-[calc(100vh-72px)] flex items-center">
      <SeoHead
        title="Client Portal (Coming Soon) | Local Proof STL"
        description="Local Proof STL client portal — coming soon. Executive dashboards, performance reporting, and every engagement deliverable in one secure client space."
        canonical="https://localproofstl.com/portal"
        ogType="website"
        ogUrl="https://localproofstl.com/portal"
        ogImage="https://localproofstl.com/og-image.jpg"
        twitterImage="https://localproofstl.com/og-image.jpg"
      />
      <div className="noise-overlay" />
      <motion.div
        className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-steel/20 blur-[120px]"
        animate={{ scale: [1, 1.15, 1], opacity: [0.4, 0.6, 0.4] }}
        transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
      />
      <div className="relative max-w-[1280px] mx-auto px-6 lg:px-10 py-24 w-full">
        <div className="grid lg:grid-cols-12 gap-16 items-center">
          <div className="lg:col-span-6">
            <span className="inline-block text-xs uppercase tracking-widest text-mist border border-white/20 rounded-full px-4 py-2 mb-8">
              Coming Soon
            </span>
            <h1 className="font-serif font-light text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight mb-8">
              The Client Portal.
            </h1>
            <p className="text-cloud/80 text-lg leading-relaxed max-w-lg mb-10">
              A secure home for your executive dashboards, performance reporting, and every
              deliverable from your engagement — designed with the same operational rigor we
              bring to your business.
            </p>
            <Link to="/" className="inline-flex items-center gap-2 text-mist hover:text-white transition-colors text-sm">
              <ArrowLeft size={15} /> Back home
            </Link>
          </div>
          <div className="lg:col-span-6 grid sm:grid-cols-2 gap-5">
            {FEATURES.map((f, i) => (
              <Reveal key={f.title} delay={i * 0.08}>
                <div className="border border-white/15 rounded-2xl p-6 h-full hover:bg-white/5 transition-colors duration-300">
                  <f.icon size={22} className="text-mist mb-4" />
                  <h3 className="font-serif text-xl mb-2">{f.title}</h3>
                  <p className="text-cloud/70 text-sm leading-relaxed">{f.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
